export default __webpack_public_path__ + "static/media/intensive-learning-white.9c6c05c8.svg";